import type { IconSvgObject } from './types';

const ItalicIcon: IconSvgObject = [
  ["path", { d: "M10.6667 4H20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99872 20L15.9987 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.99872 20L13.3321 20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default ItalicIcon;
